/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameter } from './SystemDropdownParameter';
import {
    SystemDropdownParameterFromJSON,
    SystemDropdownParameterFromJSONTyped,
    SystemDropdownParameterToJSON,
    SystemDropdownParameterToJSONTyped,
} from './SystemDropdownParameter';

/**
 * 
 * @export
 * @interface SystemDropdownParameterParam
 */
export interface SystemDropdownParameterParam {
    /**
     * 
     * @type {SystemDropdownParameter}
     * @memberof SystemDropdownParameterParam
     */
    parameter: SystemDropdownParameter;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownParameterParam
     */
    value: string;
}



/**
 * Check if a given object implements the SystemDropdownParameterParam interface.
 */
export function instanceOfSystemDropdownParameterParam(value: object): value is SystemDropdownParameterParam {
    if (!('parameter' in value) || value['parameter'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SystemDropdownParameterParamFromJSON(json: any): SystemDropdownParameterParam {
    return SystemDropdownParameterParamFromJSONTyped(json, false);
}

export function SystemDropdownParameterParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownParameterParam {
    if (json == null) {
        return json;
    }
    return {
        
        'parameter': SystemDropdownParameterFromJSON(json['parameter']),
        'value': json['value'],
    };
}

export function SystemDropdownParameterParamToJSON(json: any): SystemDropdownParameterParam {
    return SystemDropdownParameterParamToJSONTyped(json, false);
}

export function SystemDropdownParameterParamToJSONTyped(value?: SystemDropdownParameterParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parameter': SystemDropdownParameterToJSON(value['parameter']),
        'value': value['value'],
    };
}

